'use strict';

import * as Redux from 'redux';
import Login from '../reducers/login.js';

export default Redux.createStore(Login);
